/**
 * CfssCommunicationLogPage — QP Communication Log
 *
 * MN 256B.0659: QP must document communications with participants
 * Thin wrapper around shared CommunicationLogPage with CFSS config.
 *
 * Route: /cfss/communication
 */

import { CommunicationLogPage } from '@/pages/shared-services';

export function CfssCommunicationLogPage() {
  return (
    <CommunicationLogPage
      title="Communication Log"
      subtitle="Document contacts with participants and workers"
      subjectLabel="Participant"
      scope="qp:communication:log"
    />
  );
}

export default CfssCommunicationLogPage;
